export default __webpack_public_path__ + "static/media/binance_icon.0886fd8a.svg";